module.exports = __webpack_public_path__ + "img/chart-network.04160a68.svg";